export default __webpack_public_path__ + "static/media/quiz-background-left.21802ec5.jpg";